"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const GeoLocationController_1 = require("@bitcoin-portal/neko-web-sdk/lib/controllers/GeoLocationController");
const react_1 = require("react");
const intl_1 = require("../helpers/intl");
const store_1 = require("../context/store");
const actions_1 = require("../context/actions");
const useGeoLocation = () => {
    const dispatch = (0, store_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        const getGeo = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const res = yield GeoLocationController_1.GeoLocationController.getLocationInfo();
                const val = res.getValue();
                const country = (0, intl_1.getCountryByAlpha2)(val.countryCode);
                dispatch({
                    type: actions_1.CONTEXT_ACTIONS.SET_GEO_LOCATION,
                    payload: country,
                });
            }
            catch (error) {
                console.log("error getting geo", error);
            }
        });
        getGeo();
    }, [dispatch]);
};
exports.default = useGeoLocation;
//# sourceMappingURL=useGeoLocation.js.map